import React, { Component } from 'react';
import adresse from '../../../images/contact/pageinfo.jpg';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import './NousRetrouver.css';

function NousRetrouver() {
	return (
		<div id ="nousretrouver" className="nousRetrouver_container">
			<div className="platsTitleContainer TITRE-container">
				<Typography gutterBottom variant="h5" component="h1" className="platsTitle best_sellers">
					Nous Retrouver
				</Typography>
			</div>
			<div className="img_container">
				<div className="nousRetrouver_img">
					<img className="image" src={adresse} alt="addresse du restaurent" />
				</div>
			</div>
		</div>
	);
}
export default NousRetrouver;
